import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import Title from '../title/Title';
import Subtitle from '../subtitle/Subtitle';
import CountdownTimer from '../countdown-timer/CountdownTimer';
import { css } from 'emotion';
import { moduleMargins } from '../../Constants';
import { isMobile } from "react-device-detect";

class LeftRight extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let [marginDesktop, marginMobile] = moduleMargins(this.props.MarginDT, this.props.MarginMobile);
    const leftRightProps = {
        marginClass : (!isMobile) ? marginDesktop : marginMobile,
    }

    const mobileContent =
      isMobile && this.props.mobilecontent && this.props.mobilecontent.length
        ? this.props.mobilecontent[0]
        : null;

    const title = mobileContent && mobileContent.title || this.props.title;
    const text = mobileContent && mobileContent.text || this.props.text;
    const image = mobileContent && mobileContent.image || this.props.image;
    const altText = mobileContent && mobileContent.altText || this.props.altText;
    const cta = mobileContent && mobileContent.cta || this.props.cta;
    
    const FluidTextContainer = ({ fluid, children }) => (fluid ?
      <div className="eir-fluid-md-w50 eir-fluid-xl-w50">
        {children}
      </div>
      : children
    );

    return (
      <Container fluid={this.props.fluid} className={' eir-leftRight ' + leftRightProps.marginClass + (this.props.theme ? ' eir-theme-' + this.props.theme : ' eir-theme-default') + (this.props.countdownTimer ? ' countdown' : '')}>
        <Row className={this.props.imageAlignment == 'right' ? 'justify-content-end' : 'justify-content-start'}>
          <Col className={'col-12 col-md-6 d-flex align-items-center justify-content-center ' + (this.props.imageAlignment == 'right' ? 'order-md-3' : 'order-md-1') + ' ' + (this.props.countdownTimer ? 'eir-minh-30' : 'eir-minh-50')}>
            {image &&
              <img src={image.path} className="img-fluid" alt={altText} />
            }
          </Col>
          <Col className={'eir-minh-50 col-12 col-md-6 mt-4 d-flex align-items-center justify-content-center flex-column text-center text-md-left order-2 ' + (this.props.fluid ? '' : 'align-items-md-start') + ' ' + (this.props.countdownTimer ? '' : 'eir-minh-50')}>
            <FluidTextContainer fluid={this.props.fluid}>
              <Title title={title} fluid={this.props.fluid} useH1={this.props.useH1} className="w-100" />
              <Subtitle text={text} className="w-100" />
              {cta &&
                <div className='eir-leftRightCtaDiv'>
                  <EirButton ariaLabel={this.props.cta.ariaLabel} {...cta} />
                </div>
              }
              {this.props.countdownTimer &&
                <CountdownTimer className="pt-3 pt-md-5" date={this.props.countdownTimer.dateTime} title={this.props.countdownTimer.title} />
              }
            </FluidTextContainer>
          </Col>
        </Row>
      </Container>
    );
  }
}
export default LeftRight;
